/**
 * sparkline
 * This jQuery plugin generates sparklines (small inline charts) directly in the browser
 * using data supplied either inline in the HTML, or via javascript.
 *
 * https://omnipotent.net/jquery.sparkline/#s-about
 *
 * @package Monapix
 * @version 3.0.1
 * @author Binary Cats Inc.
 */

require ('jquery-sparkline');

$(function() {

    "use strict";

    let sparkline = $('.sparkline')

    if (sparkline) {
        sparkline.sparkline('html', {
            width:sparkline.data('sparkWidth') || 85,
            height:sparkline.data('sparkHeight') || 35,
            type: sparkline.data('sparkType') || 'bar',
            barWidth: sparkline.data('sparkBarWidth') || 3,
            barSpacing: sparkline.data('sparkBarSpacing') || 3,
            chartRangeMin: sparkline.data('sparkChartRangeMin') || 0,
            barColor: sparkline.data('sparkBarColor') || 'green',
        })
    }
});



// WEBPACK FOOTER //
// ./resources/js/services/jquery/sparkline.js